import {Component} from '@angular/core';
import {RoutesEnum} from '../../../core/services/navigation/routes.enum';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {Utils} from '@astek/utils';
import {finalize} from 'rxjs';
import {BoxRestApiService} from '../services/http/box-rest-api.service';
import {NavigationService} from '../../../core/services/navigation/navigation.service';
import {ApiBatchCreateBoxRequest} from '../services/http/api-batch-create-box-request';
import {BoxTypeEnum} from '../enum/box-type.enum';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslocoService} from '@jsverse/transloco';
import {BoxUdiEnum} from '../enum/box-udi.enum';

@Component({
  selector: 'xp-batch-create-box',
  templateUrl: './batch-create-box.component.html',
  styleUrls: ['../../crud.common.scss'],
})
export class BatchCreateBoxComponent {

  public readonly formGroup = this._formBuilder.group({
    udi: new FormControl<string>(BoxUdiEnum.UDI1, Validators.required.bind(Validators)),
    type: new FormControl<string>(BoxTypeEnum.NB1A, Validators.required.bind(Validators)),
    numberOfBox: new FormControl<number>(1, Validators.required.bind(Validators)),
  }, {validators: []});

  public isLoading: boolean = false;
  public errorKey: string = '';

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _boxRestApiService: BoxRestApiService,
    private readonly _navigationService: NavigationService,
    private readonly _snackBar: MatSnackBar,
    private readonly _translocoService: TranslocoService,
  ) {
  }

  public get boxListRoute(): Array<string> {
    return ['/', RoutesEnum.BOXES];
  }

  public get udiList(): Array<{ key: string, value: BoxUdiEnum }> {
    return Object.entries(BoxUdiEnum).map(([key, value]) => {
      return {
        key: key,
        value: value,
      };
    });
  }

  public get typeList(): Array<{ key: string, value: BoxTypeEnum }> {
    return Object.entries(BoxTypeEnum).map(([key, value]) => {
      return {
        key: key,
        value: value,
      };
    });
  }

  public onSubmit(): void {
    if (this.formGroup.invalid ||
      Utils.isBlank(this.formGroup.controls.udi.value) ||
      Utils.isBlank(this.formGroup.controls.type.value) ||
      Utils.isNull(this.formGroup.controls.numberOfBox.value)
    ) {
      return;
    }
    this.isLoading = true;
    this.errorKey = '';

    const data: ApiBatchCreateBoxRequest = {
      udi: this.formGroup.controls.udi.value,
      type: this.formGroup.controls.type.value,
      numberOfBox: this.formGroup.controls.numberOfBox.value,
    };

    this._boxRestApiService.requestBatchCreate(data).pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: async () => {
          this._snackBar.open(
            this._translocoService.translate('BOXES.BATCH_CREATE.SUCCESS'),
            '',
            {duration: 7000},
          );
          await this._navigationService.navigateTo(RoutesEnum.BOXES);
        },
        error: () => this.errorKey = 'SHARED.ERRORS.UNKNOWN',
      });
  }
}
